import { S1DataTransferFolder } from "./S1DataTransferFolder.enum";

export class S1DataTransferInfo {
    filename: string;
    fileSize: number;
    overwrite: boolean = true;
    folder: S1DataTransferFolder;
    processCode: string;
    fileHash: any;
}